import * as math from "mathjs";
import Vue from "vue";

/**
 * 在fieldAttr中获取field一致的所有字段信息
 * @param {*} fieldAttr 字段信息
 * @param {*} field 唯一标识
 */
function findFieldInfos(fieldAttr, field) {
  if (!Array.isArray(fieldAttr)) {
    return null;
  }
  let infos = fieldAttr.filter(item => {
    return item.field === field || item.uuid === field;
  });
  return infos;
}

/**
 * 在fieldAttr中获取唯一的字段信息
 * @param {} fieldAttr 字段信息
 * @param {*} field 字段唯一标识
 */
function findFieldInfo(fieldAttr, field) {
  let infos = findFieldInfos(fieldAttr, field);
  return infos[0];
}

/**
 * 根据field查找需要的字段信息
 * @param {*} fieldAttr 计算区域的字段信息
 * @param {*} mainFieldAttr 计算区域的字段信息
 * @param {*} fieldInfo 触发的字段信息
 * @param {*} field 需要寻找的字段
 */
function findFieldSubDetailInfo(fieldAttr, mainFieldAttr, fieldInfo, field) {
  let info = findFieldInfo(fieldAttr, field);
  if (!info) {
    info = findFieldInfo(mainFieldAttr, field);
  }
  if (!info && mainFieldAttr) {
    let detailInfo = findFieldParentInfo(mainFieldAttr, field);
    if (!detailInfo) {
      return null;
    }
    info = findFieldInfo(detailInfo.sub, field);
  }
  return info;
}

/**
 * 根据field查找需要的字段信息的value
 * @param {*} fieldAttr 计算区域的字段信息
 * @param {*} mainFieldAttr 计算区域的字段信息
 * @param {*} fieldInfo 触发的字段信息
 * @param {*} field 需要寻找的字段
 */
function findFieldSubDetailInfoValue(fieldAttr, mainFieldAttr, fieldInfo, field) {
  let info = findFieldSubDetailInfo(fieldAttr, mainFieldAttr, fieldInfo, field);
  if (info && info.value && info.value.toString().length > 0) {
    if (info.fieldType.toString() === "3" && 
    parseInt(info.percentFlag, 10) === 0) {
      return info.value / 100;
    }
    return info.value;
  }
  return "0";
}

/**
 * 根据字段寻找寻找明细区某条数据
 * @param {*} fieldAttr 区域
 * @param {*} changeFieldItem
 */
function findFieldSubDetailInfos(fieldAttr, changeFieldItem) {
  if (!changeFieldItem) {
    return null;
  }
  let detailInfo = findFieldParentInfo(fieldAttr, changeFieldItem.field);
  if (!detailInfo) {
    return null;
  }
  let subDetailInfos = detailInfo.sub.filter(item => {
    return item.filter(item1 => {
      return item1 === changeFieldItem;
    }).length > 0;
  });
  if (subDetailInfos.length > 0) {
    return subDetailInfos[0];
  }
  return null;
}

/**
 * 根据字段寻找明细区字段
 * @param {*} fieldAttr
 * @param {*} field
 */
function findFieldParentInfo(fieldAttr, field) {
  let infos = fieldAttr.filter(item => {
    let fieldType = item.fieldType.toString();
    if (fieldType === "11" || fieldType === "18" || fieldType === "19") {
      if (Array.isArray(item.sub)) {
        for (const sub of item.sub) {
          if (findFieldInfo(sub, field)) {
            return true;
          }
        }
      }
    }
    return false;
  });
  if (infos.length > 0) {
    return infos[0];
  }
  return null;
}

/**
 * 拼接表达式字符串
 * @param {*} changeFieldItem 触发的字段
 * @param {*} computeRuleItem 计算公式配置
 * @param {*} fieldAttr 计算区域字段
 * @param {*} mainFieldAttr 主表区字段
 */
function expression(changeFieldItem, computeRuleItem, fieldAttr, mainFieldAttr) {
  let expressionString = "";
  for (const expressRuleItem of computeRuleItem.expressRule) {
    if (expressRuleItem.key === "fun") {
      if (expressRuleItem.name.toLowerCase() !== "sum") {
        return;
      }
      let expressRuleFunItems = expressRuleItem.value.filter(item => {
        return item.key === "fields";
      });
      if (expressRuleFunItems.length == 0) {
        return;
      }
      let srcFieldInfo = findFieldInfo(fieldAttr, computeRuleItem.srcField);
      let numbers = [];
      if (srcFieldInfo) {
        for (const expressRuleFunItem of expressRuleFunItems) {
          let numberValue = findFieldSubDetailInfoValue(fieldAttr, null, null, expressRuleFunItem.value);
          if (numberValue) {
            numbers.push(numberValue);
          }
        }
      }else{
        for (const expressRuleFunItem of expressRuleFunItems) {
          let detailInfo = findFieldParentInfo(mainFieldAttr, expressRuleFunItem.value);
          if (detailInfo && Array.isArray(detailInfo.sub)) {
            for (const sufInfos of detailInfo.sub) {
               let value = findFieldSubDetailInfoValue(sufInfos, null, null, expressRuleFunItem.value);
               if (value) {
                  numbers.push(value);
               }
            }
          }
        }
      }
      expressionString += numbers.length > 0 ? math.sum(numbers) : "0";
    } else if (expressRuleItem.key === "fields") {
      let value = findFieldSubDetailInfoValue(fieldAttr, mainFieldAttr, changeFieldItem, expressRuleItem.value);
      expressionString += value;
    } else if (expressRuleItem.key === "oper" || expressRuleItem.key === "constant") {
      expressionString += expressRuleItem.value;
    }
  }
  return expressionString;
}

/**
 * 计算主表区或者明细区某条数据
 * @param {*} changeFieldItem 触发的字段
 * @param {*} computeRuleItem 计算公式配置
 * @param {*} fieldAttr 计算区域所有字段
 * @param {*} mainFieldAttr 主表区数据
 */
function calculateArea(changeFieldItem,
  computeRuleItem,
  fieldAttr,
  mainFieldAttr,
  computeRuleInfo,
  repeat) {
  let srcFieldInfo = findFieldInfo(fieldAttr, computeRuleItem.srcField);
  if (!srcFieldInfo) {
    srcFieldInfo = findFieldInfo(mainFieldAttr, computeRuleItem.srcField);
  }
  if (!srcFieldInfo) {
    return;
  }
  try { 
    let expressionFormat = expression(changeFieldItem, computeRuleItem, fieldAttr, mainFieldAttr);
    let value = math.evaluate(expressionFormat);

    ///小数位数据
    if (isFinite(value)) {
      if (srcFieldInfo.fieldType.toString() === "4") {
        value = value.toFixed(2);
      } else if (srcFieldInfo.fieldType.toString() === "3") {
        if (parseInt(srcFieldInfo.percentFlag, 10) === 0) {
          value = value.toFixed(srcFieldInfo.reserverDecimal + 2);
        }else{
          value = value.toFixed(srcFieldInfo.reserverDecimal);
        }
      }
    }else{
      value = 0;
    }
    srcFieldInfo._setValue(value);
    Vue.set(srcFieldInfo, "value", value);

    if (repeat) {
      // groupCompute(computeRuleInfo, computeRuleItem, changeFieldItem, fieldAttr, mainFieldAttr);
    }
  } catch (error) {
    srcFieldInfo._setValue("");
    Vue.set(srcFieldInfo, "value", "");
  }
}

/**
 * 计算一组计算公式
 * @param {*} computeRuleInfo 计算公式配置信息
 * @param {*} computeRuleList 计算公式
 * @param {*} changeFieldItem 改变字段
 * @param {*} fieldAttr 改变区域字段
 * @param {*} mainFieldAttr 主表区字段
 * @param {*} repeat 重复执行
 */
function calculateFormula(computeRuleInfo, computeRuleList, changeFieldItem,
   fieldAttr, mainFieldAttr, repeat = false) {
  for (const computeRuleItem of computeRuleList) {
    let areaInfos = findFieldSubDetailInfos(mainFieldAttr, changeFieldItem);
    if (areaInfos) {
      calculateArea(changeFieldItem,
        computeRuleItem,
          areaInfos,
          mainFieldAttr,
          computeRuleInfo, repeat);
    }else{
      let detailInfo = findFieldParentInfo(fieldAttr, changeFieldItem, computeRuleItem.srcField);
      if (detailInfo) {
        for (const subInfos of detailInfo.sub) {
          calculateArea(changeFieldItem,
             computeRuleItem,
             subInfos,
              mainFieldAttr,
              computeRuleInfo, repeat);
        }
      }else{
        calculateArea(changeFieldItem, computeRuleItem, fieldAttr, mainFieldAttr, computeRuleInfo, repeat);
      }
    }
  }
}

// /**
//  * 计算分组计算公式
//  * @param {*} computeRuleInfo 计算公式map
//  * @param {*} computeRuleItem 触发字段信息
//  * @param {*} changeFieldItem 修改字段
//  * @param {*} fieldAttr 改变区域数据
//  * @param {*} mainFieldAttr 主表区数据
//  */
// function groupCompute(computeRuleInfo, computeRuleItem, changeFieldItem,
//   fieldAttr, mainFieldAttr) {
//  computeRuleItem.groupNumber = "";
//   if (computeRuleItem.groupNumber.length == 0) {
//     return;
//   }
//   let groupComputeRuleList = computeRuleInfo[computeRuleItem.srcField];
//   if (!Array.isArray(groupComputeRuleList)) {
//     return;
//   }
//   groupComputeRuleList = groupComputeRuleList.filter(item => {
//     return computeRuleItem.groupNumber == item.groupNumber;
//   });
//   if (groupComputeRuleList.length == 0) {
//     return;
//   }
//   groupComputeRuleList.sort(function(item1, item2) {
//     return item1.groupSort - item2.groupSort;
//   });
//   calculateFormula(computeRuleInfo,
//     groupComputeRuleList,
//     changeFieldItem,
//     fieldAttr,
//      mainFieldAttr, false);
// }

/**
 * 获取触发的计算公式
 * @param {*} changeFieldItem 触发的字段
 * @param {*} computeRuleInfo 计算公式配置{key:触发的字段,value:计算公式}
 * @param {*} fieldAttr 主表区数据
 */
export function calculate(changeFieldItem, computeRuleInfo = {}, fieldAttr = []) {
  //不触发计算公式
  if (computeRuleInfo.length === 0 ||
    fieldAttr.length === 0 ||
    changeFieldItem.field.length === 0) {
    return;
  }
  //需要计算的公式
  let computeRuleList = computeRuleInfo[changeFieldItem.field];
  if (!computeRuleList) {
    return;
  }
  calculateFormula(computeRuleInfo, computeRuleList, changeFieldItem, fieldAttr, fieldAttr, true);
}
